import "babel-polyfill";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import App from "./screens/App";
import registerServiceWorker from "./registerServiceWorker";
import { Location } from "./utils/location";
import ReactGA from "react-ga";
import store from "./stores.js";
import "./assets/css/style.css";
import TagManager from "react-gtm-module";
import Upload from "./wrapper/uikit/upload";
import { configureSentry } from "../src/config/sentry";

configureSentry();

declare var UIkit;

if (process.env.REACT_APP_MODE == "production") {
  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_TAG, {
    debug: false,
  });

  const TagManagerArgs = {
    gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER,
  };
  TagManager.initialize(TagManagerArgs);
}
UIkit.component("upload", Upload);
UIkit.icon.add("x-twitter", '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>');

// Load Stripe outside of the component tree
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

ReactDOM.render(
  <Provider store={store}>
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ""}
    >
      <Elements stripe={stripePromise}>
        <App lang={Location.getLang()} />
      </Elements>
    </GoogleReCaptchaProvider>
  </Provider>,
  document.getElementById("root"),
);
registerServiceWorker();
